import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as sasdActionTypes from '../sasdActionTypes';

/**
 * Update SASD service provider flow
 */
const updateSASDServiceProviderFlow = function* updateSASDServiceProviderFlow() {
    while (true) {
        const {payload} = yield take(sasdActionTypes.SUBMIT_SASD_SERVICE_PROVIDER_FORM);
        const {serviceAssignmentLineNo, serviceCaseId, serviceAssignmentData} = payload;

        yield* updateServiceAssignment({
            caller: sasdActionTypes.SUBMIT_SASD_SERVICE_PROVIDER_FORM,
            assignmentType: efServiceAssignmentTypes.SUBSTITUTE_DRIVER,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: sasdActionTypes.SUBMIT_SASD_SERVICE_PROVIDER_FORM},
        });
    }
};

export default updateSASDServiceProviderFlow;
